import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadWallPlannerTeamsActivities,
  loadWallPlannerWorkGroupActivities
} from "../pages/wallPlanner.duck";
import { selectCalendarDate } from "@shared/store/dashboard.duck";
import { selectFollowingTeams, selectFollowingWorkGroups } from '@features/whereabouts/store/followingTeamsAndTags.duck';
import { TeamEntity } from '@shared/models/team.models';
import { Tag } from '@shared/models/tags.models';

interface Groups {
  teams: TeamEntity[];
  workGroups: Tag[];
}

// Loads the month's activities for each group into the wall planner slice.
// Defaults to the user's followed groups; pass `groups` to load an explicit
// set instead (used by whereabouts pages pinned to one team or workgroup).
export function WithWorkPlannerUserActivities(groups?: Groups) {
  const dispatch = useDispatch();
  const followedTeams = useSelector(selectFollowingTeams);
  const followedWorkGroups = useSelector(selectFollowingWorkGroups);
  const calendarDate = useSelector(selectCalendarDate);
  const teams = groups?.teams ?? followedTeams;
  const workGroups = groups?.workGroups ?? followedWorkGroups;

  useEffect(() => {
    const id = setTimeout(() => {
      teams.forEach((team) => dispatch(loadWallPlannerTeamsActivities(team)))
    }, 250);

    return () => {
      clearTimeout(id);
    }
  }, [dispatch, teams, calendarDate]);

  useEffect(() => {
    const id = setTimeout(() => {
      workGroups.forEach((tag) => dispatch(loadWallPlannerWorkGroupActivities(tag)))
    }, 350);

    return () => {
      clearTimeout(id);
    }
  }, [dispatch, workGroups, calendarDate]);
}
